<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img src="@/assets/img/logo_white.svg" alt="logo图">
    </div>
    <p class="title">上海展域航空技术有限公司</p>
    <p class="address_tel_fax">
      <span>地址：上海市徐汇区漕溪路252号银海大楼C-406</span>
      <br>
      <span>联系电话：15086621233</span>
    </p>
    <p class="email_wx">
      <span>邮箱：zhanyuhangkong@163.com</span>
      <br>
      <span>微信号：15086621233</span>
    </p>
    <p class="copy">
    <span>
      Copyright &copy;  {{ new Date().getFullYear() }} 上海展域航空技术有限公司
    </span>
    <br>
    <span>
      沪ICP备2023024212号-1
    </span>
    </p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #2b2b2b;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 180px;
  height: 100%;
  margin: 30px auto 30px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue